export const getIsNAASupported = () =>
  Office.context.requirements.isSetSupported('NestedAppAuth', '1.1');
